var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 6.66683C8.66675 8.13959 7.47284 9.3335 6.00008 9.3335C4.52732 9.3335 3.33341 8.13959 3.33341 6.66683C3.33341 5.19407 4.52732 4.00016 6.00008 4.00016C7.47284 4.00016 8.66675 5.19407 8.66675 6.66683Z",
    stroke: "#000536",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 6.66683C11.3334 9.61235 7.33341 14.6668 6.00008 14.6668C4.66675 14.6668 0.666748 9.61235 0.666748 6.66683C0.666748 3.72131 3.05456 1.3335 6.00008 1.3335C8.9456 1.3335 11.3334 3.72131 11.3334 6.66683Z",
    stroke: "#000536",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGps);
export default __webpack_public_path__ + "static/media/gps.8ea29a45d1bd6fb2d8ee74aaf5affe57.svg";
export { ForwardRef as ReactComponent };